import { client } from "./client";

// eslint-disable-next-line object-shorthand
export const list = params => client.get("deposits", { params: params });
// export const download = params => client.get('deposits/export.json', { params: params });

export const get = id => client.get(`deposit/${id}`);

export const exportDeposits = params => client.post("deposits/export", params);

export const downloadExport = params => client.get("deposits/download_export", { params: params });

export const checkExportStatus = () => client.get("deposits/check_export_status");
